import { render, staticRenderFns } from "./LeftSwiper.vue?vue&type=template&id=00b88dec&scoped=true"
import script from "./LeftSwiper.vue?vue&type=script&lang=js"
export * from "./LeftSwiper.vue?vue&type=script&lang=js"
import style0 from "./LeftSwiper.vue?vue&type=style&index=0&id=00b88dec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b88dec",
  null
  
)

export default component.exports